import { normalizeLocale, sourceLocale } from "@hallyulytics/i18n";
import type { LoaderFunctionArgs, RouteObject } from "react-router";
import { appConfig } from "./config";
import { HomePage } from "./pages/HomePage";

export async function homeLoader({ request }: LoaderFunctionArgs) {
  const locale = normalizeLocale(request.headers.get("x-hallyulytics-locale")) ?? sourceLocale;
  const highlights = fetch(new URL("/api/v1/deferred", request.url), {
    signal: request.signal,
  }).then(async (response) => {
    if (!response.ok) throw new Error("Deferred endpoint unavailable");
    return response.json() as Promise<Array<{ label: string; value: string; detail: string }>>;
  });
  return { ...appConfig, locale, highlights };
}

export const routes: RouteObject[] = [{ path: "/", loader: homeLoader, Component: HomePage }];
